import PostHeader from './PostHeader';

export default PostHeader;
export * as PostHeaderStyles from './PostHeader.styles';
export * as PostHeaderTypes from './PostHeader.types';
